'use client'
import { Controller } from 'react-hook-form'
import MaskedInput from 'react-text-mask'
import { useEffect, useState } from 'react'
import Icon from 'components/ui/icon/Icon'
import FieldInput from '../field-input/input'
import FieldLabel from '../field-label'
import { computedClass } from 'utils'
import './style.scss'

function FieldText(props) {
    let {
        onFocus,
        onBlur,
        mark,
        mask,
        control,
        onClear,
        clear,
        fieldStyle,
        icon,
		  hidden,
        placeholder,
        suffix,
        date,
        validation = {},
        TITLE: label,
        value,
        controlled,
        labelMark,
        ...rest
    } = props
    // const { value } = rest
    const { required } = validation
    const [activated, setActivated] = useState(false)

    const classes = computedClass({
        'field-input-block--large': fieldStyle === 'large',
        'field-input-block--date': date,
        'field-input-block--complex': fieldStyle === 'large',
        'field-input-block--icon': icon,
        'field-input-block--activated': activated,
    })

    const onFocusHandler = (ev) => {
        setActivated(true)
        onFocus && onFocus(ev)
    }

    const onBlurHandler = (ev) => {
        onBlur && onBlur(ev)
        setTimeout(() => {
            if (!ev.target?.value) {
                setActivated(false)
            }
        }, 0)
    }

    const inputClasses = computedClass({
        'field-input--lg': fieldStyle === 'large',
        'field-input--mask':mask,
    })

    useEffect(() => {
        if (value) {
            setActivated(true)
        }
    }, [value])





    return (
        <div className={`field-text field-input-block ${classes}`}>
            {label && !hidden && (
                <FieldLabel label={label} required={required || rest.required} labelMark={labelMark}></FieldLabel>
            )}
            <div className="field-text__main">
                {mask && (
                    <Controller
                        control={control}
                        name={rest.name}
                        rules={validation}
                        {...rest}
                        render={({ field }) => {
                            const { onBlur, onChange, ref, ...rest } = field
                            const onBlurHandler = (ev) => {
                                !rest.value && setActivated(false)
                                onBlur && onBlur(ev)
                            }

                            return (
                                <MaskedInput
                                    mask={mask}
                                    // guide={true}
                                    onBlur={onBlurHandler}
                                    onChange={onChange}
												// showMask={true}
                                    placeholder={placeholder}												
                                    {...rest}
                                    render={(maskref, props) => {
                                        return (
                                            <FieldInput
                                                ref={(e) => {
                                                    maskref(e)
                                                    ref(e)
                                                }}
                                                {...props}
                                                className={inputClasses}
                                            ></FieldInput>
                                        )
                                    }}
                                />
                            )
                        }}
                    />
                )}
                {!mask && (
                    <FieldInput
                        {...rest}
                        {...(controlled && { value })}
								date={date}
								placeholder={placeholder}
                        onBlur={onBlurHandler}
                        onFocus={onFocusHandler}
                        className={inputClasses}
                    ></FieldInput>
                )}

                {icon && (
                    <Icon name="search" className="field-input-block__icon">
                        {' '}
                    </Icon>
                )}
                {date && (
                    <Icon name="i-date" className="field-input-block__icon">
                        {' '}
                    </Icon>
                )}
                {clear && onClear && (
                    <div onClick={onClear} className="field-input-block__clear">
                        <Icon name="close-small" className="field-input-block__clear-icon"></Icon>
                    </div>
                )}
                {mark && (
                    <div className="field-input-block__mark">
                        <Icon className="field-input-block__mark-icon" name="check"></Icon>
                    </div>
                )}
                {suffix && <div className="field-input-block__suffix">{suffix}</div>}
            </div>
        </div>
    )
}

export default FieldText
